<div class="atmos-closet-request__bg" aria-hidden="true"></div>
<div class="atmos-closet-request__vignette" aria-hidden="true"></div>

<main class="atmos-closet-request__main">
  <div class="atmos-request-page">
    <!-- Page header -->
    <div class="atmos-card">
      <div class="atmos-card__header">
        <h1 class="atmos-section__title atmos-section__title--lg">Sky outfit request</h1>
        <a class="atmos-btn atmos-btn--sm atmos-closet-request__home" [routerLink]="'/'" data-step="904" data-position="bottom-right-aligned">
          <mat-icon>home</mat-icon>
          <span>Home</span>
        </a>
      </div>
      <div class="atmos-card__body">
        <div data-step="0" data-position="bottom-left-aligned">
          Please visit the
          <a class="atmos-text-link" [routerLink]="'/outfit-request/closet'">Closet</a>
          page if you want to customize and share your closet.
        </div>
      </div>
    </div>

    <!-- Ongoing items (TS / RS / events) — request mode only -->
    <app-closet-ongoing (itemToggled)="toggleItem($event)" />

    <!-- Toolbar -->
    <app-closet-toolbar
      [isRequesting]="requesting"
      (resetRequest)="resetSelected()"
      (randomRequest)="randomSelection()"
      (copyLinkRequest)="copyLink()"
      (calculateCostRequest)="calculateCost()"
      (startTourRequest)="startTour()" />

    <!-- Background picker -->
    <app-closet-background-picker />

    <!-- Warning: problematic items -->
    @if (state.selectionHasUnavailable()) {
      <div class="atmos-card atmos-warn-hidden">
        <div class="atmos-card__body">
          <div class="atmos-warn-box">
            <mat-icon class="atmos-warn-box__icon">priority_high</mat-icon>
            <span>This selection has items not available in the shared closet.</span>
          </div>
        </div>
      </div>
    }

    <!-- Item grid header with copy controls -->
    <div class="atmos-card atmos-card--sticky-host" data-step="1" data-position="top-left-aligned">
      <div class="atmos-card__header header-sticky">
        <h2 class="atmos-section__title">Items</h2>
        <div class="atmos-copy-controls" data-step="4" data-position="bottom-left-aligned">
          <div class="atmos-btn-group">
            <button type="button" class="atmos-btn atmos-btn--sm"
              (click)="toggleImagePicker()"
              [disabled]="state.isRendering()"
              skyTooltip="Copied!" #ttCopyImage="skyTooltip" manual placement="bottom" [closeDelay]="1000"
              data-step="6" data-position="bottom-left-aligned">
              <mat-icon [class.spin]="state.isRendering() === 2">
                {{ state.isRendering() === 2 ? 'cached' : 'file_copy' }}
              </mat-icon>
              <span>Share</span>
            </button>
            <button type="button" class="atmos-btn atmos-btn--sm"
              (click)="copyLink(ttCopyLink)"
              [disabled]="state.isRendering()"
              skyTooltip="Copied!" #ttCopyLink="skyTooltip" manual placement="top" [closeDelay]="1000"
              data-step="5" data-position="bottom-left-aligned">
              <mat-icon [class.spin]="state.isRendering() === 1">
                {{ state.isRendering() === 1 ? 'cached' : 'link' }}
              </mat-icon>
            </button>
          </div>
          @if (state.selectionHasUnavailable()) {
            <span class="atmos-warn-badge" (click)="scrollToWarning()">
              <mat-icon>priority_high</mat-icon>
            </span>
          }
          @if (state.showingImagePicker()) {
            <div class="atmos-image-picker">
              <div class="atmos-btn-group btn-group-img">
                <button type="button" class="atmos-btn atmos-btn--sm btn-copy-img" (click)="shareImage('request')" data-step="8" data-position="top-left-aligned">
                  <mat-icon>background_grid_small</mat-icon>
                  <span>Share request</span>
                </button>
                <button type="button" class="atmos-btn atmos-btn--sm" (click)="copyImage('request', ttCopyImage)">
                  <mat-icon>file_copy</mat-icon>
                </button>
              </div>
              <div class="atmos-btn-group btn-group-img">
                <button type="button" class="atmos-btn atmos-btn--sm btn-copy-img" (click)="shareImage('square')" data-step="9" data-position="top-left-aligned">
                  <mat-icon>grid_on</mat-icon>
                  <span>Share one fit</span>
                </button>
                <button type="button" class="atmos-btn atmos-btn--sm" (click)="copyImage('square', ttCopyImage)">
                  <mat-icon>file_copy</mat-icon>
                </button>
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Closet grid -->
      <app-closet-grid
        [requesting]="requesting"
        (itemToggled)="toggleItem($event)"
        (dyeClicked)="showDyePicker($event.item, $event.event)" />
    </div>

    <!-- Dye picker overlay -->
    <app-closet-dye-picker (closed)="closeDyePicker()" />
  </div>
</main>
